'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('./containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(
      _reactRouter.Route,
      { path: ':lng/store' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.HomePage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'cart', component: _containers.OrderEditPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'orders/:id', component: _containers.OrderShowPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'orders/:id/:view', component: _containers.OrderShowPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'checkout/:step', component: _containers.CheckoutPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'account', component: _containers.OrderIndexPage })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFoundPage, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/routes.js
// module id = 2351
// module chunks = 0